export { default as EnvioTraslados } from "./modos/EnvioTraslados";
export { default as RecepcionTraslados } from "./modos/RecepcionTraslados";

